import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.MicroUI.Title',
    defaultMessage: 'Microapp Display Name'
  },
  titlePlaceholder: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.MicroUI.Title.Placeholder',
    defaultMessage: 'Microapp Title'
  },
  titleTooltip: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.MicroUI.TitleTooltip',
    defaultMessage:
      'This is the name that will appear to your end users in their Apps tab, and Apps Settings page of Workgrid'
  },
  description: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.MicroUI.Description',
    defaultMessage: 'Short Description of the Microapp'
  },
  descriptionPlaceholder: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.MicroUI.Description.Placeholder',
    defaultMessage: 'Microapp Description'
  },
  descriptionTooltip: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.MicroUI.DescriptionTooltip',
    defaultMessage: 'This is the description that will appear to your end users in their Apps Settings page of Workgrid'
  },
  disableCheck: {
    id: 'SpaceAppsPage.AppCatalog.Installation.DisableCheck',
    defaultMessage: 'Do you really want to disable?'
  },
  disableConfirm: {
    id: 'SpaceAppsPage.AppCatalog.Installation.DisableConfirm',
    defaultMessage: 'Yes, disable'
  },
  disablingAppUserInterface: {
    id: 'SpaceAppsPage.AppCatalog.Installation.DisablingAppUserInterface',
    defaultMessage:
      'Disabling this will remove configuration data and user access to this app, and it may remove associated log data.'
  },
  sandboxOptions: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.MicroUI.SandboxOptions',
    defaultMessage: 'Interaction Specifications'
  },
  sandboxOptionsDescription: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.MicroUI.SandboxOptionsDescription',
    defaultMessage: 'Select which attributes to allow in your app'
  },
  url: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.MicroUI.Url',
    defaultMessage: 'Microapp URL'
  },
  urlPlaceHolder: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.MicroUI.Url.Placeholder',
    defaultMessage: 'https://www.exampleurl.com/microapp'
  },
  urlTooltip: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.MicroUI.Url.ToolTip',
    defaultMessage: 'URL of the hosted Microapp'
  },
  microUI: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.MicroUI',
    defaultMessage: 'Microapp'
  },
  microUIDescription: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.MicroUIDescription',
    defaultMessage: 'This allows your employees to interact with a custom front-end app interface.'
  },
  subcomponentDescriptionOff: {
    id: 'AppInstanceForm.DescriptionOff',
    defaultMessage: 'This feature is currently OFF.'
  },
  contact: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.MicroUI.Contact',
    defaultMessage: 'Support Contact'
  },
  contactPlaceholder: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.MicroUI.Contact.Placeholder',
    defaultMessage: 'Add email address to support contact or URL to support page'
  },
  contactTooltip: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.MicroUI.Contact.Tooltip',
    defaultMessage: 'Microapp Support Contact Link'
  },
  domainWhitelist: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.MicroUI.DomainWhitelist',
    defaultMessage: 'Domain Whitelist'
  },
  audience: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.MicroUI.Audience',
    defaultMessage: 'Audience'
  },
  audienceTargeting: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.MicroUI.AudienceTargeting',
    defaultMessage: 'Audience Targeting'
  },
  audienceTargetingDescription: {
    id: 'AppInstanceForm.AudienceTargetingDescription',
    defaultMessage: 'All Members of your organization will receive the app.'
  },
  audienceTargetingSubComponentDescription: {
    id: 'AppInstanceForm.AudienceTargetingSubComponentDescription',
    defaultMessage: 'Turn on to update'
  },
  allowDetailExpand: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.MicroUI.AllowDetailExpand',
    defaultMessage: 'Layout Options'
  },
  customAccess: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.MicroUI.CustomAccess',
    defaultMessage: 'Custom Access Settings'
  },
  appDisplayName: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.MicroUI.AppDisplayName',
    defaultMessage: 'Microapp Display Name'
  },
  defaultName: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.MicroUI.DefaultName',
    defaultMessage: 'Same as App Name'
  },
  domainWhiteListToolip: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.MicroUI.DomainWhitelistField.Tooltip',
    defaultMessage: 'List of domains approved for authorized access to data'
  }
})
